var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"AddText",class:_vm.className},[_c('div',{staticClass:"AddText-Edit"},[_c('Vueditor',{ref:"editor"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }